import React from "react";
import { Modal, Button } from "react-bootstrap";
// eslint-disable-next-line no-restricted-imports
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  col: {
    "&:nth-child(2n+1)": {
      backgroundColor: "#EFF8FF",
    },
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#e2241b",
  },
  predictions: {
    width: "30px",
    textAlign: "center",
  },
});

export default function VoidTicket({
  show,
  onHide,
  data,
  handlePayVoidTicket,
}) {
  const classes = useStyles();

  return (
    <>
      <Modal centered show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title id="create">Bron edilmiş bilet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className={`col-12 col-md-12 col-lg-12 ${classes.col}`}>
                <div className="w-100 pt-2 pb-3 d-flex justify-content-between">
                  <span>
                    <b>Komandalar:</b>
                  </span>
                  <span>
                    <b>Proqnozlar:</b>
                  </span>
                </div>
              </div>
              {data?.ticketGames?.map((game, index) => (
                <div
                  key={index}
                  className={`col-12 col-md-12 col-lg-12 ${classes.col}`}
                >
                  <div className="w-100 pt-2 pb-3 d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      {index + 1}. {game.hostClub} - {game.guestClub}
                    </div>
                    <div className={classes.predictions}>
                      {game.options.option1 === true &&
                      game.options.optionX === true &&
                      game.options.option2 === true
                        ? "1/x/2"
                        : game.options.option1 === true &&
                          game.options.optionX === true
                        ? "1/x"
                        : game.options.option1 === true &&
                          game.options.option2 === true
                        ? "1/2"
                        : game.options.optionX === true &&
                          game.options.option2 === true
                        ? "x/2"
                        : game.options.option1
                        ? "1"
                        : game.options.optionX
                        ? "x"
                        : game.options.option2 && "2"}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <div>
              Biletin qiyməti: <b>{data?.price}</b>
            </div>
            <div>
              <Button onClick={handlePayVoidTicket} className="mr-2">
                Mərc et
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
